import React from 'react';

function capitalizeFirstLetter(string) {
    const result = string.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
}

const ConsumoTable = ({ dataTable, calculationType, calculatePercentage = false }) => {

    const cities = [
        "Asunción",
        "Concepción",
        "San Pedro",
        "Cordillera",
        "Guairá",
        "Caaguazú",
        "Caazapá",
        "Itapúa",
        "Misiones",
        "Paraguarí",
        "Alto Paraná",
        "Central",
        "Ñeembucú",
        "Amambay",
        "Canindeyú",
        "Presidente Hayes",
        "Boquerón",
        "Alto Paraguay"
    ];

    const masterColumnOrder = [
        "origen",
        "categoria",
        "tipo",
        "cantidad",
        "pesoProm",
        "precioMin",
        "precioMax",
        "precioProm",
        "precioUs",
        "precioTotalProm"
    ];

    function roundNumber(number) {
        if (typeof (number) === "number") {
            let rounded = Math.round(number);
            return rounded.toLocaleString();
        }
        return number;
    }

    const activeColumns = dataTable.length > 0
        ? masterColumnOrder.filter(key => Object.prototype.hasOwnProperty.call(dataTable[0], key))
        : [];

    const CalculateTotal = ({ type }) => {
        if (type === "cant") {
            let total = 0;
            dataTable.forEach((data) => {
                if (data.cantidad) total += data.cantidad;
            });
            return (
                <tr style={{ backgroundColor: "#19513cbd" }}>
                    <th style={{ color: "white" }} colSpan={1}>CANTIDAD TOTAL</th>
                    <th style={{ color: "white" }}> {total}</th>
                </tr>
            )
        }

        if (type === "liquidacion") {
            let cantTotal = 0;
            let pesoTotal = 0;
            let importeTotal = 0;

            dataTable.forEach((data) => {
                if (data.cantidad) cantTotal += data.cantidad;
                if (data.peso) pesoTotal += data.peso;
                if (data.importe) importeTotal += data.importe;
            });
            return (
                <tr style={{ backgroundColor: "#ffefef" }}>
                    <th style={{ color: "#366553" }}>TOTAL</th>
                    <th style={{ color: "#366553" }}> {cantTotal}</th>
                    <th style={{ color: "#366553" }}> {pesoTotal.toLocaleString()}</th>
                    <th></th>
                    <th style={{ color: "#366553" }}> {importeTotal.toLocaleString()}</th>
                </tr>
            )
        }
        return null;
    }

    return (
        <>
            {dataTable.length > 0 ?
                <table className="customers">
                    <tbody>
                        <tr className="backgroundTransparent">
                            {activeColumns.map((key, index) => (
                                <th key={index}>{capitalizeFirstLetter(key)}</th>
                            ))}
                        </tr>

                        {dataTable.map((data, dataIndex) => (
                            <tr key={dataIndex}>
                                {activeColumns.map((key, colIndex) => {
                                    const value = data[key];

                                    if (key === "origen") {
                                        return <td key={colIndex}>{cities[value]}</td>;
                                    }

                                    if (key === "tipo") {
                                        return <td key={colIndex}>{value}</td>;
                                    }

                                    if (["precioMax", "precioMin", "precioProm"].includes(key)) {
                                        return (
                                            <td key={colIndex}>
                                                {calculatePercentage
                                                    ? <span>{roundNumber((value * 0.05) + value)}</span>
                                                    : <span>{roundNumber(value)}</span>
                                                }
                                            </td>
                                        );
                                    }

                                    return <td key={colIndex}>{roundNumber(value)}</td>;
                                })}
                            </tr>
                        ))}
                        <CalculateTotal type={calculationType} />
                    </tbody>
                </table>
                :
                <p className="align-center">No hay información disponible.</p>
            }
        </>
    )
}

export default ConsumoTable;
